import React from 'react';
import * as firebase from 'firebase/app';
import { useLocalStorage } from '@rehooks/local-storage';

// https://forums.meteor.com/t/dynamic-import-of-locale-data-from-react-intl/48229
// functi\

function loadMessage(locale: string | null) {
  switch (locale) {
    case 'en':
      return import('translations/locales/en.json').then(
        messageData => messageData.default
      );
    default:
      // eslint-disable-next-line no-undef
      return Promise.resolve(null);
  }
}

interface LocaleWithMessage {
  locale: string;
  messages: any;
}

const SUPPORT_LOCALES = (process.env['REACT_APP_LOCALES'] as string).split(',');

function useIntlLocale(): LocaleWithMessage {
  const [messages, setMessages] = React.useState<{} | null>(null);

  // https://medium.com/@jamieallen59/using-react-intl-with-create-react-app-6667ee3e19f3
  const language =
    (navigator.languages && navigator.languages[0]) || navigator.language;
  const languageWithouthRegionCode = language.toLowerCase().split(/[_-]+/)[0];

  let [locale] = useLocalStorage('locale');
  locale = locale || languageWithouthRegionCode;
  if (!SUPPORT_LOCALES.includes(locale)) {
    locale = 'en';
  }

  React.useEffect(() => {
    firebase.auth().languageCode = locale;

    // https://github.com/facebook/react/issues/14326
    async function loadLocaleMessage() {
      const messageData = await loadMessage(locale);
      setMessages(messageData);
      // const localeData = await loadLocale(locale);
      // addLocaleData(localeData.default);
    }
    loadLocaleMessage();
  }, [locale]);

  return { locale, messages };
}

export default useIntlLocale;
